import React from "react";
import { getOrderPlatformMeta } from "../../../utils/orderMarketplacePlatform";
import MarketplacePlatformIcon from "./MarketplacePlatformIcon";

const BUNDLED_ICON_KEYS = new Set([
  "amazon",
  "flipkart",
  "shopify",
  "myntra",
  "meesho",
  "snapdeal",
]);

export default function OrderPlatformBadge({
  order,
  meta: metaOverride,
  size = 20,
  className = "",
  /** Smaller Importerr wordmark for dense table rows only; default keeps size elsewhere. */
  compactImporterrWordmark = false,
}) {
  const meta = metaOverride || getOrderPlatformMeta(order);
  const isWordmark = meta.key === "importerr";
  const useBundledIcon = BUNDLED_ICON_KEYS.has(meta.key);

  const wordmarkStyle =
    isWordmark && compactImporterrWordmark
      ? { maxHeight: 14, maxWidth: 72, width: "auto", height: "auto" }
      : isWordmark
        ? { maxHeight: Math.max(18, size), maxWidth: 120, width: "auto", height: "auto" }
        : {};

  return (
    <span
      className={className}
      title={meta.label}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        fontSize: "12px",
        fontWeight: 600,
        color: "#374151",
      }}
    >
      {useBundledIcon ? (
        <MarketplacePlatformIcon platformKey={meta.key} size={size} />
      ) : meta.iconUrl ? (
        <img
          src={meta.iconUrl}
          alt={isWordmark ? "Importerr" : ""}
          width={isWordmark ? undefined : size}
          height={isWordmark ? undefined : size}
          style={{
            objectFit: "contain",
            flexShrink: 0,
            borderRadius: 2,
            ...wordmarkStyle,
          }}
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      ) : (
        <span
          style={{
            width: size,
            height: size,
            borderRadius: 4,
            background: "#e5e7eb",
            color: "#6b7280",
            fontSize: Math.max(10, size - 8),
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            fontWeight: 700,
          }}
          aria-hidden
        >
          {meta.key === "unknown" ? "?" : meta.label.charAt(0)}
        </span>
      )}
      {!isWordmark && !useBundledIcon ? (
        <span style={{ whiteSpace: "nowrap" }}>{meta.label}</span>
      ) : null}
    </span>
  );
}
